export default __webpack_public_path__ + "static/img-app-explain--mobile-560d63980bbfe7c2d39d9fd599f3104a.webp";